import { useEffect, useState } from 'react';
import { useApi } from 'api/api-context';
import { DeviceListEvidenceFieldsResponse } from 'api/actions/device-list-evidence-fields/device-list-evidence-fields-response';

/** Retains the last layout while loading a scope and ignores obsolete responses. */
export default function useDeviceEvidenceFields(departmentId: string, deviceSubtypeId: string, enabled: boolean) {
  const { getAction } = useApi();
  const scope = `${departmentId}:${deviceSubtypeId}:${enabled}`;
  const [state, setState] = useState<{
    scope: string;
    fields: DeviceListEvidenceFieldsResponse;
    loading: boolean;
    error: boolean;
  }>({ scope: '', fields: [], loading: true, error: false });
  const applicable = enabled && Boolean(departmentId && deviceSubtypeId);
  useEffect(() => {
    if (!applicable) return undefined;
    let current = true;
    setState((previous) => ({ ...previous, scope, loading: true, error: false }));
    getAction('DeviceListEvidenceFields')({ parameters: { departmentId, deviceSubtypeId } })
      .then((fields) => {
        if (current) setState({ scope, fields, loading: false, error: false });
      })
      .catch(() => {
        if (current) setState((previous) => ({ ...previous, scope, loading: false, error: true }));
      });
    return () => {
      current = false;
    };
  }, [getAction, scope, applicable, departmentId, deviceSubtypeId]);
  if (!applicable) return { fields: [], loading: false, error: false };
  return state.scope === scope ? state : { fields: state.fields, loading: true, error: false };
}
